import { render, staticRenderFns } from "./Remittances.vue?vue&type=template&id=1a4dc6ea&scoped=true&"
import script from "./Remittances.vue?vue&type=script&lang=js&"
export * from "./Remittances.vue?vue&type=script&lang=js&"
import style0 from "./Remittances.vue?vue&type=style&index=0&id=1a4dc6ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4dc6ea",
  null
  
)

export default component.exports